import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth-service';
import { ClientDetailService } from '../services/client-detail-service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
class PermissionsService {
  constructor(private auth: AuthService, private router: Router, private clientDetailService: ClientDetailService, private userService: UserService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (!this.auth.isAuthenticated()) {
      let url = !this.clientDetailService.CLIENT_ID ? '/lendisoft' : `/${this.clientDetailService.CLIENT_ID}`;
      const windowURL = window.location.pathname.split("/");
      const clientId = (windowURL.length > 1) ? windowURL[1] : '';

      if (!clientId) {
        url = '/lendisoft';
      } else {
        let isLoginAsClient = this.userService.getLoginType(clientId);
        if (!isLoginAsClient) {
          url = `/${clientId}`;
        } else {
          return true;
        }
      }
      this.router.navigate([url]);
      return false;
    }
    return true;
  }
}
export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}
